










import { defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useEmailVerification from "@/hooks/useEmailVerification";
import { yMetrics } from "@/lib/analytics";
import providers from "@/lib/api";
import SixDigitConfirmView from "@/components/SixDigitConfirmView";

export default defineComponent({
  name: "SignUpEmailConfirmCode",
  components: { SixDigitConfirmView },
  setup(_, { emit }) {
    const { setUserVerificationStatus } = useEmailVerification();
    const { authUser } = useAuthUser();
    const processingConfirmation = ref(false);

    const codeResend = () => {
      if (!authUser.value) return;
      providers.EmailVerificationProvider.start({ userId: authUser.value.id });
    };

    const submit = async (code: string) => {
      if (!authUser.value) return;
      try {
        processingConfirmation.value = true;
        const data = {
          userId: authUser.value.id,
          code,
        };

        const res = await providers.EmailVerificationProvider.verify({ data });
        await setUserVerificationStatus(res);
        if (res) {
          emit("login", true);
        }
      } finally {
        processingConfirmation.value = false;
      }
    };
    yMetrics.signupWithoutCode();
    return {
      email: (authUser.value && authUser.value.email) || "",
      submit,
      codeResend,
      processingConfirmation,
    };
  },
});
